import isEmail from 'validator/lib/isEmail';

export function validateEmail(email: string) {
  return isEmail(email) && !email.endsWith('.con');
}
